const KEY = "seller_onboarding";

export const getOnboardingStorage = () => {
  const data = localStorage.getItem(KEY);
  return data ? JSON.parse(data) : {};
};

export const saveSection = (section, values) => {
  const existing = getOnboardingStorage();

  const updated = {
    ...existing,
    [section]: values,
  };

  localStorage.setItem(KEY, JSON.stringify(updated));
};

export const clearSection = (section) => {
  const existing = getOnboardingStorage();
  delete existing[section];
  localStorage.setItem(KEY, JSON.stringify(existing));
};